import { Navigate, useLocation } from 'react-router-dom';
import { LoadingContent } from '@/components/Loading';
import { useClub } from '../ClubContext';
import { clubHasFeatureForPath } from '../constants/clubNavConfig';

/**
 * Redireciona para /clube/dashboard se a rota exige function que o clube não tem.
 */
export default function ClubFeatureGate({ children }) {
    const location = useLocation();
    const { club, clubCapabilities } = useClub();

    if (!club) {
        return <LoadingContent />;
    }

    if (!clubHasFeatureForPath(location.pathname, clubCapabilities)) {
        return <Navigate to="/clube/dashboard" replace />;
    }

    return children;
}
